"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_product_fruits_1 = require("react-product-fruits");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const AuthService_1 = __importDefault(require("modules/auth/AuthService"));
const productFruitsUtil_1 = __importDefault(require("./productFruitsUtil"));
const PRODUCT_FRUIT_ID = 'NMm6Zoiy4c6t2oL1';
const ProductFruits = ({ userId, userEmail, shortLocale, productId, subdomain }) => {
    (0, react_1.useEffect)(() => {
        return () => productFruitsUtil_1.default.destroy();
    }, []);
    const user = {
        username: userEmail,
        email: userEmail,
        role: AuthService_1.default.adminRole,
        props: {
            language: shortLocale,
            userId,
            productId,
            subdomain
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_product_fruits_1.ProductFruits, { workspaceCode: PRODUCT_FRUIT_ID, language: shortLocale, user: user }));
};
exports.default = (0, flowRight_1.default)((0, mobx_react_1.inject)(({ UserStore, MembershipStore }) => {
    return {
        userId: UserStore.marketplaceId,
        userEmail: UserStore.email,
        shortLocale: UserStore.shortLocale,
        productId: MembershipStore.productId,
        subdomain: MembershipStore.subdomain
    };
}))(ProductFruits);
